import { PrivacyPolicy } from 'pages/PrivacyPolicy';
import { TermsOfService } from 'pages/TermsOfService';

export const useGeneralRoutes = () => {
  const routes = [
    {
      path: 'terms-of-service',
      element: <TermsOfService />,
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicy />,
    },
  ];

  return routes;
};
